export default class {
    headerTop = document.querySelector('.header__top');
 
    constructor() {
       this.listen();
    }
 
    listen() {
        window.addEventListener('scroll', () => {
            let scrollTop = document.documentElement.scrollTop;
            
            if (scrollTop > 0 && window.innerWidth <= 1094) {
                this.headerTop.classList.add('header__top--fix')
            } else {
                this.headerTop.classList.remove('header__top--fix')
            }         
        })
    }
 }